import WorkbookService from 'services/workbook_apis'
import { call, put, takeEvery } from 'redux-saga/effects'

/*********
 *
 *
 * fetchWorkbook() EXECUTES TWO REQUEST
 * FETCHES THE WORKBOOK DETAILS FIRST
 * SECOND IT EXECUTES THE SELECTED WORKBOOK
 * DEPENDENCY IS IN DOUBT YET
 * @param param
 * @returns {Generator<<"CALL", CallEffectDescriptor>|<"PUT", PutEffectDescriptor<{payload: *, type: string}>>, void, *>}\
 *
 *
 *******/

function* fetchWorkbook(param) {
  let payloadToFetchDetails = {
    ssid: param.payload.SSID,
    ScopeID: 'AWM-LShGslBMebhdjcgl',
    addfilters: [
      {
        filter_key: 'ID',
        filter_condition: 'AND',
        filter_operand: '=',
        filter_value: param.payload.workbookID,
        type: 'fuzzy',
      },
      {
        filter_key: 'ConfType',
        filter_condition: 'AND',
        filter_operand: '=',
        filter_value: 'WorkBooks',
      },
    ],
  }

  let payloadToExecuteWorkbook = {
    job_type: 'workbook',
    job_execution: 'on-demand',
    directive: 'return',
    ScopeID: 'lightning',
    ID: param.payload.workbookID,
  }

  try {
    yield put({ type: 'ENABLE_LOADER' })
    let start_time = window.performance.now()
    let workbookDetails = yield call(
      WorkbookService.searchWorkbook,
      payloadToFetchDetails,
      param.payload.SSID,
    )
    let executionResults = (yield call(
      WorkbookService.executeWorkbook,
      payloadToExecuteWorkbook,
      param.payload.SSID,
    )).data
    let properties = workbookDetails.data[0].properties
    // //console.log(properties)
    // //console.log(executionResults.data)
    yield put({ type: 'DISABLE_LOADER' })
    let end_time = window.performance.now()
    /*****************RESPONSE CHECK IS PENDING*****************/
    yield put({ type: 'UPDATE_PROPERTIES', payload: properties })
    let executionTime = (end_time - start_time) / 1000
    yield put({ type: 'UPDATE_EXECUTION_DETAILS', payload: { executionResults, executionTime } })
  } catch (e) {}
}

// function processProperties(properties) {}
export default function* mySaga() {
  yield takeEvery('FETCH_WORKBOOK', fetchWorkbook)
}
